/** Spanish dictionary. */
const es = {
  nav: {
    dashboard: 'Panel',
    products: 'Productos',
    website: 'Sitio web',
    advertorials: 'Advertoriales',
    ads: 'Anuncios',
    splitTesting: 'Pruebas A/B',
    findUpsells: 'Buscar upsells',
    findProducts: 'Buscar productos',
    aiChat: 'Chat IA',
    referAndEarn: 'Recomienda y gana',
    settings: 'Ajustes',
    notifications: 'Notificaciones',
    aiSuggestions: 'Sugerencias IA',
    noSuggestions: 'Aún no hay sugerencias — ¡vuelve pronto!',
    caughtUp: 'Estás al día',
    noNotificationsBody: 'Aquí te avisaremos cuando termine una creación o la IA tenga una sugerencia para tu tienda.',
    groups: {
      create: 'Crear',
      grow: 'Crecer',
      assistant: 'Asistente',
      account: 'Cuenta',
    },
  },
  common: {
    generate: 'Generar',
    publish: 'Publicar',
    download: 'Descargar',
    downloadAll: 'Descargar todo',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Atrás',
    next: 'Siguiente',
    continue: 'Continuar',
    done: 'Listo',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    close: 'Cerrar',
    loading: 'Cargando...',
    loadingStore: 'Cargando tu tienda…',
    product: 'Producto',
    selectProduct: 'Selecciona un producto',
    pleaseChooseProduct: 'Por favor elige un producto',
    markComplete: 'Marcar como completado',
    copyHtml: 'Copiar HTML',
    settingsSaved: 'Ajustes guardados',
    alreadyGenerating: 'Esto ya se está generando — mira el indicador de progreso abajo a la derecha.',
    generationStarted: 'Generación iniciada — puedes salir de esta página, te avisaremos cuando termine.',
    open: 'Abrir',
    tryAgain: 'Reintentar',
    viewLive: 'Ver página publicada',
    preview: 'Vista previa',
  },
  dashboard: {
    suggestions: 'Sugerencias IA',
    dismiss: 'Descartar',
    adPerformance: 'Rendimiento de anuncios — últimos 30 días',
    badgeNew: 'Nuevo',
    badgeComingSoon: 'Próximamente',
    metrics: {
      totalSpend: 'Gasto total',
      roas: 'ROAS',
      purchases: 'Compras',
      revenue: 'Ingresos',
      clicks: 'Clics',
      ctr: 'CTR',
    },
    capabilities: {
      buildProducts: {
        title: 'Crea productos desde cero',
        desc: 'Sube una foto o pega una URL — la IA crea el producto completo, imágenes, precios y una página de producto de alta conversión.',
      },
      fullWebsite: {
        title: 'Crea un sitio web completo',
        desc: 'Inicio, sobre nosotros, contacto — una tienda de marca completa alrededor de tu producto.',
      },
      imageAds: {
        title: 'Anuncios de imagen',
        desc: '20 creatividades DTC profesionales por producto, listas para Meta.',
      },
      videoAds: {
        title: 'Anuncios de vídeo',
        desc: 'Anuncios de vídeo generados por IA que convierten en Meta y TikTok.',
      },
      advertorials: {
        title: 'Advertoriales',
        desc: 'Artículos con estilo editorial que venden — historia, investigación, listas y más.',
      },
      releaseAds: {
        title: 'Crea y publica anuncios',
        desc: 'La IA escribe el texto, monta la campaña y la publica en tu cuenta de Meta.',
      },
      splitTesting: {
        title: 'Pruebas A/B',
        desc: 'Prueba precios, ofertas, imágenes, textos y páginas para descubrir qué gana.',
      },
      scaling: {
        title: 'Sugerencias de escalado',
        desc: 'La IA rastrea los anuncios ganadores y te dice exactamente qué escalar y cuándo.',
      },
      winningAds: {
        title: 'Detección de anuncios ganadores',
        desc: 'La IA encuentra tus mejores anuncios y crea más basándose en lo que funciona.',
      },
      aiAssistant: {
        title: 'Asistente IA',
        desc: 'Pídele lo que sea — cambiar un precio, arreglar una página, montar una prueba, escalar un anuncio.',
      },
      themeEditorAi: {
        title: 'Autonoma IA en el editor de temas',
        desc: 'Haz clic en cualquier sección del editor de temas de Shopify y dile a la IA qué cambiar, en cualquier tema.',
      },
      mobileApp: {
        title: 'Gestiona desde tu móvil',
        desc: 'Dirige tu tienda y lanza anuncios desde la app móvil estés donde estés.',
      },
    },
    mobileAppModal: {
      title: 'Descarga la app de Autonoma en tu móvil',
      subtitle: 'Copia el enlace y ábrelo en tu dispositivo — o abre la tienda directamente.',
      ios: 'iOS — App Store',
      android: 'Android — Google Play',
      open: 'Abrir',
      copyLink: 'Copiar enlace',
      copied: 'Copiado',
      close: 'Cerrar',
    },
    title: 'Panel',
    subtitle: 'Crea productos, páginas, anuncios y sitios web, y deja que la IA siga mejorándolos.',
    primaryAction: 'Crear un producto',
    capabilitiesTitle: 'Todo lo que Autonoma puede hacer',
    capabilitiesSubtitle: 'Elige una herramienta para empezar. Las funciones marcadas como “Automático” funcionan solas en cuanto tus anuncios tienen datos.',
    automatic: 'Automático',
    automaticHint: 'Funciona sola en cuanto tus anuncios tienen datos; no hay nada que configurar.',
    gettingStarted: {
      title: 'Primeros pasos',
      progress: '{done} de {total} completados; el siguiente paso está resaltado.',
      hide: 'Ocultar',
      doneCta: 'Hecho',
      product: {
        title: 'Crea un producto',
        desc: 'Sube una foto y creamos el producto, las imágenes y la página.',
        cta: 'Crear un producto',
      },
      ads: {
        title: 'Crea anuncios',
        desc: 'Anuncios con imagen, anuncios en vídeo y textos para tu producto.',
        cta: 'Crear anuncios',
      },
      meta: {
        title: 'Conecta Meta y lanza',
        desc: 'Conecta tu cuenta publicitaria y publica una campaña.',
        cta: 'Conectar Meta',
      },
      website: {
        title: 'Crea un sitio web',
        desc: 'Una tienda completa con tu marca alrededor de tus productos.',
        cta: 'Crear un sitio web',
      },
    },
  },
  ads: {
    imageN: 'Imagen {n}',
    brief: {
      label: 'Brief', open: 'Ver el brief de la imagen', title: 'Brief de la imagen', close: 'Cerrar',
      layout: 'Diseño', purpose: 'Propósito', attempts: '{n} intentos', textRendered: 'Texto compuesto por nosotros', compositeUsed: 'Producto real integrado',
      pass: 'aprobado', fail: 'fallido', gateIdentity: 'Identidad', gateText: 'Texto', gateAesthetics: 'Estética', gateArrows: 'Flechas',
      overlays: 'Texto en la imagen (exacto)', camera: 'Cámara', lighting: 'Iluminación', background: 'Fondo', negativeSpace: 'Espacio libre',
      finalPrompt: 'Prompt final', copy: 'Copiar', copied: 'Copiado',
    },
    title: 'Anuncios',
    subtitle: 'Crea, revisa y publica anuncios de Meta — paso a paso',
    tabCreate: 'Crear nuevo',
    tabInProgress: 'En progreso',
    tabCompleted: 'Completados',
    tabStrategy: 'Estrategia',
    stepSetup: 'Configuración',
    stepCreatives: 'Creatividades',
    stepCopy: 'Texto',
    stepPublish: 'Publicar',
    generateAds: 'Generar anuncios',
    clickToSelect: 'Haz clic en las imágenes para seleccionarlas.',
    campaignSetup: 'Configuración de campaña',
    campaignName: 'Nombre de la campaña',
    adSetName: 'Nombre del conjunto de anuncios',
    dailyBudget: 'Presupuesto diario',
    countries: 'Países',
    publishAds: 'Publicar anuncios',
    connectAdAccount: 'Conectar cuenta publicitaria',
    setup: {
      account: {
        title: 'Conecta tu cuenta publicitaria de Meta para publicar',
        body: 'Tus anuncios están listos. Para publicar hace falta una cuenta publicitaria de Meta conectada: tarda un minuto en Ajustes y luego vuelve aquí.',
        cta: 'Conectar cuenta publicitaria',
      },
      page: {
        title: 'Selecciona una página de Facebook para publicar',
        body: 'Meta necesita una página de Facebook para crear los creativos. Elige una en Ajustes y luego vuelve aquí.',
        cta: 'Seleccionar página de Facebook',
      },
      pixel: {
        title: 'Configura tu píxel de Meta para publicar',
        body: 'Los anuncios optimizados para compras necesitan tu píxel con el evento Compra. Configúralo en Ajustes y luego vuelve aquí.',
        cta: 'Configurar el píxel',
      },
    },
    connectToPublish: 'Conecta tu cuenta publicitaria para publicar.',
    adCopy: 'Texto del anuncio',
    generateCopy: 'Generar texto',
    useExistingCopy: 'Usar texto existente',
    noInProgress: 'No hay anuncios en progreso. Empieza uno desde la pestaña Crear nuevo — tu progreso se guarda automáticamente en cada paso.',
    noCompleted: 'Aún no hay campañas completadas.',
    createNewAds: 'Crear nuevos anuncios',
    imageAds: 'Anuncios de imagen',
    videoAds: 'Anuncios de vídeo',
    writeManually: 'Escribir manualmente',
    manualCopyTitle: 'Escribe tu propio texto de anuncio',
    manualCopyHelp: 'El primer texto principal y el primer titular son obligatorios — el resto son opcionales pero recomendados para que Meta pruebe más variaciones.',
    primaryText: 'Texto principal',
    headline: 'Titular',
    required: 'obligatorio',
    recommended: 'recomendado',
    manualValidation: 'Añade al menos el primer texto principal y el primer titular para continuar.',
    emptyInProgressTitle: 'Nada en curso',
    emptyCompletedTitle: 'Aún no hay creaciones de anuncios terminadas',
    emptyCompletedBody: 'Las creaciones terminadas aparecen aquí en modo de solo lectura. Inicia una desde Crear nuevo.',
    progressTitle: 'Creando tus anuncios',
    progressSteps: {
      study: 'Estudiando las fotos de tu producto',
      design: 'Diseñando tus creatividades',
      render: 'Generando tus imágenes',
      renderVideo: 'Generando tus imágenes y vídeos',
      review: 'Preparándolos para revisar',
    },
    cancelGeneration: 'Cancelar esta creación',
    cancelConfirm: '¿Cancelar esta creación?',
    cancelTitle: 'Cancelar creación',
    liveTitle: 'Tu campaña está activa 🚀',
    liveBody: '{n} anuncio(s) en circulación gastando tu presupuesto diario.',
    pausedTitle: 'Tu campaña está creada y desactivada 🎉',
    pausedBody: 'Todavía no se gasta nada. Actívala cuando quieras o revísala antes en Meta.',
    viewInAdsManager: 'Ver en el Administrador de anuncios',
    createMore: 'Crear más anuncios',
    turnOnTitle: 'Activar la campaña',
    turnOnDesc: 'Empieza a gastar tu presupuesto diario de inmediato.',
    turnOn: 'Activar',
    reviewInMetaTitle: 'Revisarla antes en Meta',
    reviewInMetaDesc: 'Comprueba los anuncios, el público y el presupuesto en el Administrador de anuncios antes de gastar.',
    barTitle: 'Publicar {n} anuncio(s) en Meta',
    barActive: 'Empezarán a circular en cuanto se publiquen.',
    barPaused: 'Se crean desactivados; no se gasta nada hasta que los actives.',
    next: {
      performance: {
        title: 'Sigue los resultados',
        desc: 'El gasto, el ROAS y las compras aparecen en tu panel en cuanto Meta informa.',
        cta: 'Ir al panel',
      },
      split: {
        title: 'Haz un test A/B de la página de destino',
        desc: 'Prueba precios, ofertas y versiones de página para mejorar la conversión.',
        cta: 'Iniciar un test A/B',
      },
    },
  },
  advertorials: {
    title: 'Advertoriales',
    subtitle: 'Genera páginas editoriales largas que se leen como artículos de prensa y venden productos',
    generate: 'Generar advertorial',
    publish: 'Publicar advertorial',
    published: '¡Advertorial publicado!',
    createAdsQuestion: '¿Crear anuncios con este enfoque?',
    yesCreateAds: 'Sí, crear anuncios',
    noThanks: 'No, gracias',
    tabCreate: 'Crear nuevo',
    tabPrevious: 'Creados anteriormente',
    allProducts: 'Todos los productos',
    filterByProduct: 'Filtrar por producto',
    noPrevious: 'Aún no hay advertoriales — crea el primero desde la pestaña Crear nuevo.',
    editWithAi: 'Abrir y editar con IA',
    createAdsFor: 'Crear anuncios para el advertorial',
    viewLive: 'Ver página publicada',
    updated: '¡Advertorial actualizado!',
    created: 'Creado',
    setupEyebrow: 'Configuración',
    setupTitle: 'Elige un producto y un estilo',
    startError: 'No se pudo iniciar el advertorial',
    progressTitle: 'Escribiendo tu advertorial',
    progressSteps: {
      research: 'Investigando el producto y el público',
      write: 'Escribiendo el artículo',
      images: 'Creando imágenes',
      layout: 'Maquetando la página',
    },
    reviewEyebrow: 'Revisión',
    reviewTitle: 'Tu advertorial',
    reviewHint: 'Léelo, haz clic en cualquier parte para cambiarla y publícalo cuando estés conforme.',
    draftLabel: 'Borrador: aún no publicado',
    publishError: 'No se pudo publicar el advertorial',
    liveTitle: 'Tu advertorial está publicado 🎉',
    editInThemeEditor: 'Editar en el editor de temas',
    createAnother: 'Crear otro advertorial',
    emptyTitle: 'Aún no hay advertoriales',
    next: {
      ads: {
        title: 'Crea anuncios con este enfoque',
        desc: 'Anuncios que llevan a tu advertorial, con los mismos pasos: creatividades → texto → publicar.',
      },
      edit: {
        title: 'Ver todos tus advertoriales',
        desc: 'Abre, edita con IA o crea anuncios para cualquier advertorial anterior.',
        cta: 'Ver todos',
      },
    },
  },
  products: {
    title: 'Productos',
    subtitle: 'Todo lo que Autonoma ha creado o lo que vive en tu tienda',
    createNew: 'Crear nuevo producto',
    createImages: 'Crear imágenes',
    createPage: 'Crear página de producto',
    loading: 'Cargando tus productos…',
    loadError: 'No se pudieron cargar tus productos',
    emptyTitle: 'Aún no hay productos',
    emptyBody: 'Crea tu primer producto: sube una foto y creamos el producto, las imágenes y la página.',
    statusActive: 'Activo',
    statusDraft: 'Borrador',
  },
  newProduct: {
    addPhotos: 'Añadir fotos del producto',
    variantName: 'Nombre de la variante',
    variantNameN: 'Nombre de la variante {n}',
    title: 'Nuevo producto',
    subtitle: 'Sube fotos de tu producto (URL opcional) — Autonoma crea el producto y la página',
    startError: 'No se pudo iniciar la creación',
    barTitle: 'Cuando quieras',
    barReady: 'Crearemos el producto, las imágenes y la página en unos 5 minutos.',
    barNeedPhoto: 'Sube al menos una foto del producto para empezar.',
    starting: 'Iniciando…',
    generateOne: 'Generar producto + página',
    generateMany: 'Generar {n} productos + páginas',
    progressTitle: 'Creando tu producto y tu página',
    progressSteps: {
      read: 'Leyendo tus fotos y notas',
      write: 'Escribiendo tu producto y tu página',
      images: 'Creando imágenes del producto',
      shopify: 'Configurándolo en Shopify',
    },
    cancelBuild: 'Cancelar esta creación',
    cancelConfirm: '¿Cancelar esta creación?',
    cancelTitle: 'Cancelar creación',
    cancelIt: 'Cancelar',
    previewError: 'No se pudo cargar la vista previa de la página',
    loadingPreview: 'Cargando la vista previa de tu página…',
    sections: {
      photos: 'Fotos',
      source: 'Origen · opcional',
      details: 'Detalles · opcional',
      style: 'Estilo de página',
    },
  },
  createImages: {
    settingsSummary: '{product} · {n} imágenes en este lote',
    newBatch: 'Nuevo lote',
    title: 'Crear imágenes de producto',
    subtitle: 'Fotografía de producto nueva con IA a partir de tus fotos actuales',
    progressTitle: 'Creando {n} imágenes…',
    progressSteps: {
      study: 'Estudiando tu producto…',
      design: 'Planificando cada toma…',
      render: 'Generando imágenes…',
      finish: 'Últimos retoques…',
    },
    cancelConfirm: '¿Cancelar la creación de estas imágenes?',
    cancelTitle: 'Cancelar imágenes',
    publishedTitle: '{n} imágenes publicadas en tu producto 🎉',
    publishedBody: 'La primera es ahora la imagen principal del producto.',
    nextAds: 'Crear anuncios con estas imágenes',
    barTitle: 'Imágenes del producto',
    barSelected: '{n} de {total} seleccionadas',
    downloadSelected: 'Descargar {n} seleccionadas',
    downloadAll: 'Descargar todas',
    publishN: 'Publicar {n} en la página de producto',
  },
  createPage: {
    title: 'Crear página de producto',
    subtitle: 'Una página de producto de alta conversión para un producto existente',
    progressTitle: 'Creando tu página de producto…',
    progressPreview: 'Preparando la vista previa…',
    alreadyGenerating: 'Ya se está creando una página para este producto; sigue su progreso en el indicador de abajo a la derecha.',
  },
  upsell: {
    title: 'Descubrir upsells',
    subtitle: 'Encuentra productos complementarios que tus competidores empaquetan con los tuyos — la forma más rápida de subir el ticket medio',
    flowPick: 'Elegir upsell',
    previewTitle: 'Vista previa de tu upsell',
    publishedTitle: 'Upsell publicado',
    previewSubtitle: '“{upsell}” como complemento opcional de “{main}”',
    liveTitle: 'Tu upsell está activo 🎉',
    liveBody: 'Aparece como complemento opcional junto a Añadir al carrito en “{main}”. Quienes lo marquen reciben ambos artículos juntos en el carrito.',
    liveBodyNoBlock: 'El producto de upsell y su página están publicados. El bloque de complemento necesita un paso manual; míralo abajo.',
    blockManualTitle: 'Añade el bloque de complemento a tu página de producto',
    viewMainPage: 'Ver la página del producto',
    viewUpsellPage: 'Ver la página del upsell',
    nothingLiveTitle: 'Todavía no hay nada publicado',
    nothingLiveBody: 'Revisa ambas piezas abajo y ajústalas hasta que estés conforme; después publica. Publicar activa el producto de upsell, pone su página en línea y añade el bloque de complemento opcional junto a Añadir al carrito en “{main}”.',
    barLive: 'Publicado en tu tienda',
    barDraft: 'Borrador: publica ambas piezas con un clic',
    publishError: 'No se pudo publicar el upsell',
    publishAll: 'Publicar upsell',
    republish: 'Volver a publicar',
    discoverProgressTitle: 'Buscando upsells',
    discoverSteps: {
      scan: 'Analizando tu catálogo',
      research: 'Investigando qué combina bien',
      rank: 'Clasificando las mejores opciones',
    },
    buildProgressTitle: 'Creando “{name}”',
    yourUpsell: 'tu upsell',
    buildSteps: {
      product: 'Creando el producto de upsell',
      page: 'Escribiendo su página de producto',
      block: 'Diseñando el bloque de complemento',
    },
    noneTitle: 'No se obtuvieron recomendaciones',
    noneBody: 'Ocurre de vez en cuando; vuelve a intentarlo en un momento.',
    next: {
      ads: {
        title: 'Crear anuncios para el producto principal',
        desc: 'Envía tráfico a la página que ahora incluye el upsell.',
        cta: 'Crear anuncios',
      },
      another: {
        title: 'Buscar otro upsell',
        desc: 'Añade más complementos a otros productos.',
        cta: 'Buscar upsells',
      },
    },
  },
  splitTesting: {
    metrics: {
      variant: 'Cada versión que se está probando',
      split: 'Porcentaje de visitantes que ven esta versión',
      sessions: 'Visitas a esta versión',
      purchases: 'Pedidos de esta versión',
      revenue: 'Ventas de esta versión',
      cvr: 'Tasa de conversión — pedidos ÷ visitas',
      aov: 'Valor medio del pedido — ingresos ÷ pedidos',
      roas: 'Retorno de la inversión publicitaria — ingresos ÷ gasto en anuncios',
      rpv: 'Ingresos por visitante — ingresos ÷ visitas',
      legendProb: 'P(best) = probabilidad de que esta versión sea la mejor',
      legend: 'CVR = tasa de conversión · AOV = valor medio del pedido · ROAS = retorno de la inversión publicitaria · ★ = objetivo de esta prueba',
    },
    title: 'Pruebas A/B',
    subtitle: 'Prueba precios, páginas y ofertas — descubre qué convierte mejor',
    tabs: {
      create: 'Crear nuevo',
      active: 'Activos',
      paused: 'En pausa',
      completed: 'Completados',
    },
    flow: {
      type: 'Tipo de test',
      setup: 'Configurar',
      launch: 'Vista previa y lanzamiento',
    },
    pickProduct: 'Elige un producto',
    whatToTest: '¿Qué quieres probar?',
    previewVariants: 'Vista previa de tus variantes',
    progressTitle: 'Creando tus variantes…',
    progressSteps: {
      read: 'Leyendo tu página actual…',
      write: 'Escribiendo cada variante…',
      images: 'Creando imágenes…',
      preview: 'Preparando las vistas previas…',
    },
    cancelBuild: 'Cancelar esta creación',
    cancelConfirm: '¿Cancelar la creación de estas variantes?',
    cancelTitle: 'Cancelar creación',
    buildFailedTitle: 'No pudimos crear las variantes',
    buildFailedHint: 'Ajusta las descripciones de las variantes arriba y vuelve a intentarlo.',
    runningTitle: 'Tu test está en marcha 🎉',
    runningBody: 'El tráfico ya se reparte entre tus variantes. Los resultados se actualizan en directo a medida que llegan visitas.',
    viewResults: 'Ver resultados',
    viewActive: 'Ver tests activos',
    createTest: 'Crear un test',
    emptyActiveTitle: 'No hay tests activos',
    emptyActiveBody: 'Probar continuamente es como crecen las tiendas: empieza con un test de precio u oferta.',
    emptyPausedTitle: 'No hay tests en pausa',
    emptyPausedBody: 'Pausar un test detiene el reparto de tráfico y la recogida de datos; reanúdalo cuando quieras y continúa donde lo dejaste.',
    parity: {
      blockedTitle: 'Este producto no puede ejecutar un test con producto variante',
      warnTitle: 'Aviso: apps vinculadas a este producto',
      warnFooter: 'Los tests de precio, imagen, oferta y bundle envían al grupo B a un producto variante. El stock, el perfil de envío y los descuentos se mantienen sincronizados automáticamente durante todo el test; los puntos anteriores dependen del ID del producto y puede que no le sigan. Los tests de página de producto con tus propias URL no se ven afectados.',
    },
    storefront: {
      pauseAll: 'Pausar todos los tests ({n})',
      pauseAllHint: 'Parada de emergencia: pausa todos los tests en curso y apaga el script de la tienda. Los compradores ven tus páginas normales en menos de 60 segundos.',
      deliveryTitle: 'Tus tests aún no llegan a los compradores',
      deliveryBody: 'Esta tienda no tiene activo ni el script tag antiguo de Autonoma ni el app embed de Autonoma AI, así que ningún comprador entra en un test (Shopify dejó de permitir nuevos script tags el 1 de oct. de 2026). Activa el app embed en el editor de temas y pulsa Guardar: tarda menos de un minuto.',
      deliveryEnable: 'Activar el app embed',
      pauseAllConfirm: '¿Pausar todos los tests en curso y apagar el script de split testing de esta tienda? Los compradores verán tus páginas normales en menos de 60 segundos. Podrás reanudar los tests después.',
      pausedAllNotice: '{n} test(s) pausados y script de la tienda apagado. Los compradores ven tus páginas normales en menos de 60 segundos.',
      offTitle: 'Los split tests están APAGADOS en tu tienda',
      offBody: 'Mientras esté apagado, ningún visitante es redirigido, nada se oculta y no se toca ningún carrito; las asignaciones existentes se ignoran.',
      offPauseAll: 'Pausaste todos los tests el {since}.',
      offManual: 'El script de la tienda se apagó el {since}.',
      offParity: 'Autonoma apagó el script de la tienda el {since} porque un producto variante dejó de coincidir con el original (ver el test pausado).',
      offGlobal: 'El equipo de Autonoma ha apagado los split tests en todas las tiendas mientras se investiga un problema.',
      turnOn: 'Volver a encender los split tests en la tienda',
      errorTitle: 'Eso no ha funcionado',
    },
    emptyCompletedTitle: 'Aún no hay tests completados',
    emptyCompletedBody: 'Los resultados aparecen aquí cuando un test alcanza su umbral de datos o cuando lo finalizas.',
  },
  website: {
    title: 'Creador de sitios web',
    subtitle: 'Crea una tienda multi-producto — inicio, navegación, logo, nombre de negocio, políticas y marca en el checkout — alrededor de tus productos seleccionados',
    startError: 'No se pudo iniciar la creación del sitio web',
    previousTitle: 'Sitios web anteriores',
    previousEmpty: 'Aún no hay sitio web: crea el primero abajo.',
    productsError: 'No se pudieron cargar tus productos',
    searchProducts: 'Buscar productos',
    selectAll: 'Seleccionar todo',
    clear: 'Limpiar',
    selectedCount: '{n} de {total} seleccionados',
    noMatches: 'Ningún producto coincide con esa búsqueda.',
    showAll: 'Mostrar los {n} productos',
    showFewer: 'Mostrar menos',
    barTitle: 'Listo para crear',
    barNoProducts: 'Crea un producto primero.',
    barPickProducts: 'Selecciona al menos un producto arriba.',
    barTitlePending: 'Casi listo',
    barNeedName: 'Añade un nombre de negocio o marca “Dejar que la IA cree el nombre de mi negocio”.',
    barReady: 'Creación alrededor de {n} producto(s): unos 5 minutos.',
    buildCta: 'Crear mi sitio web',
    progressTitle: 'Creando tu sitio web',
    progressSteps: {
      brand: 'Definiendo el nombre, los colores y el logotipo de tu marca',
      homepage: 'Escribiendo tu página de inicio',
      images: 'Creando imágenes del sitio web',
      pages: 'Configurando páginas, menús y colecciones',
    },
    cancelBuild: 'Cancelar esta creación',
    cancelConfirm: '¿Cancelar la creación de este sitio web?',
    cancelTitle: 'Cancelar creación del sitio web',
    liveTitle: 'Tu sitio web está publicado 🎉',
    liveBody: 'La página de inicio, las páginas Sobre nosotros y Contacto, las políticas, los menús y las colecciones ya están publicados en tu tienda.',
    viewStorefront: 'Ver la tienda publicada',
    openAbout: 'Abrir la página Sobre nosotros',
    refineHomepage: 'Ajustar la página de inicio',
    buildAnother: 'Crear otro sitio web',
    previewReadyTitle: 'La vista previa de tu sitio web está lista',
    previewReadyBody: 'Todavía no hay nada publicado. Revisa la vista previa de abajo, escribe los cambios que quieras y publica para poner todo el sitio en línea: páginas, políticas, menús y colecciones incluidos.',
    logo: {
      eyebrow: 'Tu logo',
      title: 'Logo de la marca',
      dims: 'PNG transparente de {w}×{h}',
      sourceGenerated: 'Generado para {name}',
      sourceUploaded: 'Tu logo subido',
      sourceTheme: 'El logo actual de tu tema',
      sourceBrand: 'Tu logo de Marca de Shopify',
      download: 'Descargar PNG (280×80)',
      generateAnother: 'Generar otro',
      uploadOwn: 'Subir el mío',
      undo: 'Deshacer — restaurar el logo anterior',
      generating: 'Diseñando otro logo…',
      uploading: 'Subiendo tu logo…',
      setInTheme: 'Aplicado en el tema “{theme}” — {where}',
      whereGlobal: 'ajustes del tema (selector de imagen de logo)',
      whereHeader: 'sección de encabezado (selector de imagen de logo)',
      whereBoth: 'ajustes del tema + sección de encabezado',
      keptCurrent: 'Se conservó tu logo actual: no se reemplazó nada en el tema.',
      notApplied: 'Aún no aplicado en el tema',
      noLogoSetting: 'Este tema no tiene un ajuste de imagen de logo: descarga el PNG y súbelo en el editor de temas.',
      willApply: 'Publica el sitio web para aplicarlo en el encabezado de tu tema (140 px de ancho).',
      restored: 'Logo anterior restaurado en el tema.',
      failed: 'La acción del logo falló',
      choiceTitle: 'Logo',
      choiceHelp: 'Ya tienes un logo. Consérvalo o deja que la IA diseñe uno nuevo (PNG transparente de 280×80).',
      useCurrent: 'Usar mi logo actual',
      generateNew: 'Generar un logo nuevo',
      currentFrom: 'Encontrado en: {where}',
      currentTheme: 'tu tema',
      currentBrand: 'ajustes de Marca de Shopify',
    },
    openPreview: 'Abrir vista previa y publicar',
    barDraft: 'Vista previa: aún no publicado',
    pages: {
      home: 'Inicio',
      about: 'Sobre nosotros',
      contact: 'Contacto',
      aboutDesc: 'La página Sobre nosotros se redacta a partir de la historia de la marca y se crea en tu tienda al publicar el sitio web.',
      contactDesc: 'Al publicar el sitio web se crea en tu tienda una página de contacto con un formulario que funciona.',
    },
    next: {
      ads: {
        title: 'Crea anuncios para tus productos',
        desc: 'Anuncios con imagen, anuncios en vídeo y textos, listos para lanzar en Meta.',
        cta: 'Crear anuncios',
      },
      split: {
        title: 'Haz tests A/B de tus páginas',
        desc: 'Prueba precios, ofertas y versiones de página para descubrir qué vende.',
        cta: 'Iniciar un test A/B',
      },
    },
  },
  chat: {
    title: 'Chat IA',
    subtitle: 'Haz cambios en tu tienda, productos y anuncios simplemente pidiéndolos',
    placeholder: 'Pregunta a Autonoma lo que quieras sobre hacer crecer tu tienda...',
    send: 'Enviar',
    publishFailed: 'No se pudo publicar el texto del anuncio',
  },
  settings: {
    title: 'Ajustes',
    subtitle: 'Gestiona tu tienda, cuenta publicitaria, valores por defecto y plan',
    language: 'Idioma de la app',
    languageHelp: 'Detectado automáticamente desde tu admin de Shopify — cámbialo aquí si lo prefieres. Cambia el idioma de la app Y el idioma de todo el contenido generado por IA (anuncios, páginas, advertoriales, voz en off de vídeos).',
    languageSaved: 'Idioma actualizado',
    dataSharingTitle: 'Información anónima',
    dataSharingLabel: 'Comparte información de uso anonimizada y agregada para ayudar a mejorar Autonoma.',
    dataSharingHelp: 'Activado por defecto (puedes desactivarlo en cualquier momento en Ajustes). Cuando está activado, patrones anonimizados y agregados sobre qué anuncios, páginas y ofertas convierten mejoran las recomendaciones de la IA para todas las tiendas. Nunca se comparten datos personales — ni datos de clientes, ni nombres de productos, ni cifras de ventas, ni la identidad de tu tienda.',
    autoImproveTitle: 'Mejora automática',
    autoImproveLabel: 'Sugerir un test A/B cuando una página tenga suficiente tráfico y una tasa baja de añadir al carrito.',
    autoImproveHelp: 'Desactivado hasta que lo actives. Autonoma mide cómo los compradores recorren las secciones de las páginas que creó (qué secciones se ven, durante cuánto tiempo y dónde ocurre el añadir al carrito — nunca quién es el comprador) y, con esto activado, sugiere un test A/B del hero o de la oferta por página como notificación. Revisas cada variante antes de dividir el tráfico; nada se inicia solo.',
    autoImproveStats: '{views} visitas en {pages} páginas de Autonoma en los últimos {days} días · las sugerencias empiezan a partir de {min} visitas por página.',
    autoImproveNoData: 'Aún no se han medido visitas — las páginas creadas con la biblioteca de secciones actual empiezan a informar en cuanto los compradores las visitan.',
    onThisPage: 'En esta página',
    saveFailed: 'No se pudo guardar',
    metaConnectError: 'No se pudo conectar tu cuenta de Meta',
    sections: {
      plan: 'Plan y uso',
      meta: 'Cuenta de Meta Ads',
      defaults: 'Valores por defecto de anuncios',
      themeEditor: 'Editor de temas',
      mobile: 'App móvil',
      referrals: 'Recomienda y gana',
      privacy: 'Privacidad',
    },
  },
  plans: {
    title: 'Elige tu plan',
    subtitle: '{plans} incluyen {n} días de prueba gratis. Cancela cuando quieras.',
    subtitleNoTrial: 'Cancela cuando quieras.',
    andPlans: 'y',
    perMonth: '/mes',
    trialChip: '{n} días de prueba gratis',
    billedToday: 'Se factura hoy',
    mostPopular: 'El más popular',
    startTrial: 'Empezar prueba gratis',
    choose: 'Elegir {name}',
    opening: 'Abriendo Shopify…',
    loading: 'Cargando planes',
    loadError: 'No se pudieron cargar los planes — actualiza la página.',
    declined: 'Necesitas aceptar un plan para continuar — elige uno abajo para empezar.',
    unverified: 'Aún no pudimos confirmar tu suscripción con Shopify. Si aprobaste el cargo, pulsa “Volver a comprobar”; si no, elige un plan abajo.',
    checkAgain: 'Volver a comprobar',
    checking: 'Comprobando…',
    contactSupport: 'Contactar con soporte',
    reactivateTitle: 'Tu suscripción está inactiva',
    reactivateSubtitle: 'Reactívala para restaurar tus páginas, productos y anuncios — no se borra nada.',
    reactivateReason: {
      cancelled: 'Tu suscripción a Autonoma fue cancelada.',
      frozen: 'Tu suscripción está congelada — Shopify no pudo cobrar el último pago.',
      declined: 'El cargo de la suscripción fue rechazado.',
      expired: 'Tu suscripción ha caducado.',
      pending: 'Tu suscripción sigue pendiente de aprobación en Shopify.',
      test_charge_on_live_store: 'Esta suscripción de prueba no es válida en una tienda real.',
      inactive: 'Tu suscripción a Autonoma ya no está activa.',
    },
    reactivateCta: 'Reactivar {name}',
    unavailableTitle: 'No pudimos confirmar tu suscripción',
    unavailableBody: 'Shopify no respondió a tiempo, así que Autonoma aún no puede abrirse. No se pierde nada — inténtalo de nuevo en un momento.',
    tryAgain: 'Reintentar',
    checkingAccess: 'Comprobando tu suscripción…',
    genericError: 'Algo salió mal — inténtalo de nuevo.',
    keyNumbersTitle: 'Al mes',
    notIncluded: 'No incluido',
    inherits: 'Todo lo de {name}, más:',
    customLine: '¿Necesitas más límites o white-label? Planes a medida para agencias y marcas de alto volumen —',
    customCta: 'Reserva una llamada →',
    compare: 'Compara todas las funciones',
    close: 'Cerrar',
    trustRow: 'Pago seguro a través de Shopify · Cancela cuando quieras · Cambia de plan en cualquier momento',
    consentTitle: 'Comparte información anónima para ayudar a mejorar Autonoma',
    consentBody: 'Comparte información de uso anonimizada y agregada para ayudar a mejorar Autonoma. Nunca se comparten datos personales. Puedes cambiarlo en cualquier momento en Ajustes.',
    consentDefault: 'Activado por defecto (puedes desactivarlo en cualquier momento en Ajustes).',
    consentInfo: 'Más sobre compartir información anónima',
    billingNote: 'La facturación la gestiona Shopify de forma segura y aparece en tu factura de Shopify. Al suscribirte aceptas nuestros',
    and: 'y la',
    terms: 'Términos del servicio',
    privacy: 'Política de privacidad',
    // Client fallback for backends without plan.copy.tagline / highlights
    // (the server copy in plan-copy.service.js is the source of truth).
    tiers: {
      starter: {
        tagline: 'Lanza tus primeros productos ganadores',
        highlights: ['Páginas de producto con IA', 'Anuncios con sellos de oferta', 'Advertoriales que pre-venden', 'Web de marca + logo'],
      },
      growth: {
        tagline: 'Publica anuncios y eleva el ticket',
        highlights: ['Publica anuncios en Meta', 'Anuncios de feed vertical (4:5)', 'Upsells post-compra', 'App para iPhone y Android'],
      },
      scale: {
        tagline: 'Vídeo, split tests y chat con IA',
        highlights: ['Anuncios de vídeo con IA', 'Split tests con ganador claro', 'Asistente IA que hace el trabajo', 'Soporte prioritario'],
      },
      enterprise: {
        tagline: 'Para agencias y marcas de alto volumen',
        highlights: ['Límites máximos en todo', 'Prueba ángulos nuevos a diario', 'Onboarding dedicado', 'Soporte prioritario'],
      },
    },
    keyNumbers: {
      productBuilds: 'Páginas de producto',
      imageAds: 'Anuncios de imagen',
      videoAds: 'Anuncios de vídeo',
      advertorials: 'Advertoriales',
      splitTests: 'Split tests',
      findProductsSearches: 'Búsquedas de productos',
    },
    currentPlan: 'Plan actual',
  },
  planLimit: {
    titleReached: 'Has alcanzado el límite de tu plan',
    titleNotEnough: 'No te queda suficiente este mes',
    titleNear: 'Te queda poco este mes',
    reached: 'Has usado los {n} {feature} de {plan} este mes. Mejora tu plan para seguir creando — tu límite se reinicia el {date}.',
    reachedBudget: 'Has usado todo tu {feature} de {n} en {plan} este mes. Mejora tu plan para seguir creando — tu límite se reinicia el {date}.',
    notEnough: 'Te quedan {x} {feature} este mes. Esto necesita {y}. Mejora tu plan para hacerlo ahora.',
    notEnoughBudget: 'Te quedan {x} de {feature} este mes. Esto necesita {y}. Mejora tu plan para hacerlo ahora.',
    notEnoughUnknown: 'Te quedan {x} {feature} este mes — no es suficiente para esto. Mejora tu plan para hacerlo ahora.',
    left: 'Te quedan {x} {feature} este mes.',
    allowance: '{n} {feature} / mes',
    allowanceBudget: '{n} {feature} / mes',
    allowanceUnlimited: '{feature} ilimitados',
    allowanceNone: 'No incluido en este plan',
    topTierTitle: 'Estás en nuestro plan más alto',
    topTierBody: '¿Necesitas más {feature} este mes? Creamos planes personalizados con límites más altos para agencias y marcas de alto volumen.',
    topTierCta: 'Contáctanos para un plan personalizado',
    referLine: 'O recomienda una tienda — ambos recibís créditos extra.',
    referCta: 'Recomienda y gana',
    nearLimit: 'Te quedan {n} {feature} este mes',
    nearLimitBudget: 'Te quedan {n} de {feature} este mes',
    viewPlans: 'Ver planes',
    upgraded: 'Plan mejorado — ya puedes generar.',
    loadError: 'No se pudieron cargar los planes — inténtalo de nuevo.',
    subscribeError: 'No se pudo iniciar la mejora — inténtalo de nuevo.',
    close: 'Cerrar',
  },
  generations: {
    title: 'Creaciones anteriores',
    tabAll: 'Todas',
    tabTrash: 'Papelera',
    trashNote: 'Los elementos eliminados permanecen aquí {n} días: restáuralos o elimínalos definitivamente.',
    trashEmpty: 'La papelera está vacía.',
    empty: 'Todavía no has creado nada.',
    viewEdit: 'Ver / editar',
    moveToTrash: 'Mover a la papelera',
    restore: 'Restaurar',
    deleteForever: 'Eliminar definitivamente',
    deletedIn: 'se eliminará definitivamente {when}',
    status: {
      draft: 'Borrador',
      published: 'Publicado',
      replaced: 'Reemplazado',
      trashed: 'En la papelera',
    },
  },
  productDetail: {
    loading: 'Cargando producto…',
    loadError: 'No se pudo cargar este producto',
    backToProducts: 'Volver a productos',
    editInShopify: 'Editar en Shopify',
    draftNote: 'Borrador: publica el producto en Shopify para obtener un enlace a la página publicada.',
    whatToCreate: '¿Qué quieres crear?',
    pagesTitle: 'Páginas de producto de este producto',
    pagesEmpty: 'Todavía no se ha creado ninguna página para este producto.',
    pagesEmptyCta: 'Crear la página de producto',
    othersTitle: 'Advertoriales y packs de anuncios de este producto',
    othersEmpty: 'Aún no hay advertoriales ni packs de anuncios.',
    chatPrompt: '¿Prefieres describir el cambio?',
    chatCta: 'Chatear con la IA',
    actions: {
      ads: {
        title: 'Crear anuncios para este producto',
        desc: 'Creatividades con imagen y vídeo, listas para publicar en Meta.',
      },
      images: {
        title: 'Crear imágenes del producto',
        desc: 'Nueva fotografía de producto con IA a partir de tus fotos actuales.',
      },
      page: {
        title: 'Crear página de producto',
        desc: 'Una página de producto de alta conversión en el estilo que elijas.',
      },
      advertorial: {
        title: 'Crear advertorial',
        desc: 'Un artículo con estilo editorial que vende: historia, investigación, lista.',
      },
      splitTest: {
        title: 'Crear test A/B',
        desc: 'Compara precios, ofertas o páginas de producto entre sí.',
      },
      upsell: {
        title: 'Buscar productos de upsell',
        desc: 'Descubre productos complementarios que aumentan tu pedido medio.',
      },
    },
  },
  flow: {
    product: 'Producto',
    build: 'Creación',
    review: 'Revisión',
    publish: 'Publicar',
    setup: 'Configuración',
    customise: 'Personalizar',
    preview: 'Vista previa',
    results: 'Resultados',
  },
  findProducts: {
    title: 'Buscar productos',
    subtitle: 'Productos ganadores avalados por inversión publicitaria real; selecciones nuevas en cada búsqueda',
    progressTitle: 'Buscando productos ganadores',
    progressSteps: {
      scan: 'Analizando lo que se vende ahora mismo',
      filter: 'Filtrando para tu nicho',
      rank: 'Clasificando las mejores opciones',
    },
    cancelConfirm: '¿Cancelar esta búsqueda?',
    cancelTitle: 'Cancelar búsqueda',
    noneTitle: 'No hay productos ganadores en esta categoría',
    noneBody: 'Prueba otra categoría o repite la búsqueda; las selecciones se renuevan cada vez.',
  },
  ui: {
    nav: {
      menuLabel: 'Menú de navegación',
      lockedTitle: 'Mejora tu plan para desbloquear {name}',
    },
    progress: {
      done: '¡Listo!',
      anyMoment: 'En cualquier momento…',
      longer: 'Está tardando un poco más de lo habitual…',
      minutesLeft: 'Quedan unos {n} min',
      oneMinuteLeft: 'Queda aprox. 1 min',
      secondsLeft: 'Quedan unos {n} s',
      leaveNote: 'Te avisaremos cuando termine; puedes salir de esta página.',
      cancel: 'Cancelar',
    },
    errors: {
      retry: 'Reintentar',
      reload: 'Recargar la página',
      showDetails: 'Detalles técnicos',
      hideDetails: 'Ocultar detalles',
      generic: {
        title: 'Algo no ha funcionado',
        body: 'Vuelve a intentarlo. Si sigue pasando, escríbenos desde el botón de soporte.',
      },
      network: {
        title: 'No se puede conectar con Autonoma',
        body: 'Comprueba tu conexión a internet y vuelve a intentarlo.',
      },
      session: {
        title: 'Tu sesión ha caducado',
        body: 'Recarga la página para volver a entrar; tu trabajo está guardado.',
      },
      quota: {
        title: 'Has alcanzado el límite de tu plan',
        body: 'Mejora tu plan o espera al próximo periodo de facturación para continuar.',
      },
      notFound: {
        title: 'No encontramos eso',
        body: 'Puede que se haya eliminado. Vuelve atrás e inténtalo de nuevo.',
      },
      busy: {
        title: 'Ya está en marcha',
        body: 'Esto ya está en curso; mira el indicador de progreso abajo a la derecha.',
      },
      tooLarge: {
        title: 'Ese archivo es demasiado grande',
        body: 'Prueba con un archivo más pequeño.',
      },
      rateLimit: {
        title: 'Demasiadas solicitudes',
        body: 'Espera un minuto y vuelve a intentarlo.',
      },
      timeout: {
        title: 'Ha tardado demasiado',
        body: 'La solicitud ha caducado. Vuelve a intentarlo; normalmente funciona a la segunda.',
      },
      server: {
        title: 'Algo ha fallado de nuestro lado',
        body: 'Vuelve a intentarlo en un momento.',
      },
    },
    preview: {
      label: 'Vista previa',
      device: 'Dispositivo de vista previa',
      desktop: 'Escritorio',
      mobile: 'Móvil',
      edit: 'Editar',
      clickToEdit: 'Vista previa · haz clic para editar',
      editPage: 'Editar esta página',
    },
    success: {
      whatNext: '¿Qué quieres hacer ahora?',
    },
    session: {
      title: 'No pudimos conectar con tu tienda',
      body: 'Tu sesión de Shopify no está funcionando ahora mismo. Volver a conectar suele solucionarlo.',
    },
    themeCode: {
      getting: 'Obteniendo tu código…',
      error: 'No pudimos obtener tu código',
    },
    editor: {
      opening: 'Abriendo tu página…',
      archivedTitle: 'Esta página ha sido archivada',
      openError: 'No pudimos abrir esta página',
      publishError: 'La publicación no se completó',
      upToDate: '✓ En vivo · al día',
      upToDateHint: 'Todo en esta página está en vivo. Haz un cambio y el botón Publicar volverá a aparecer.',
      back: '← Volver',
    },
    jobs: {
      ads: 'Creando anuncios',
      advertorial: 'Creando el advertorial',
      landing_page: 'Creando la página de producto',
      website: 'Creando el sitio web',
      images: 'Creando imágenes',
      product_build: 'Creando el producto',
      split_test_build: 'Creando las variantes del test',
      split_test_setup: 'Configurando el split test',
      upsell_discovery: 'Buscando upsells',
      upsell_build: 'Creando el upsell',
      product_finder: 'Buscando productos ganadores',
      edit_own_ad: 'Editando tus anuncios',
      ad_copy: 'Escribiendo el texto del anuncio',
      cart_upgrade: 'Mejorando tu carrito',
      publish_ads: 'Publicando anuncios',
      shipping_setup: 'Configurando envíos',
      markets_update: 'Actualizando mercados',
      working: 'Trabajando',
      updating: 'Actualizando tu {what}',
    },
  },
  feedback: {
    thanksTitle: 'Gracias por tus comentarios',
    gotIt: 'Recibido — ticket #{ticket}',
    gotItBody: 'Una persona real del equipo de Autonoma lee cada uno de estos mensajes. Si necesitamos más detalles, responderemos al correo de tu tienda{email}.',
    backToDashboard: 'Volver al panel',
    sendAnother: 'Enviar otro',
  },
  featureRequest: {
    button: 'Pedir una función',
    title: 'Pedir una función',
    intro: 'Cuéntanos qué te gustaría que hiciera Autonoma: nuevas funciones, mejoras, lo que sea. Leemos todas las peticiones.',
    label: 'Tu petición',
    placeholder: 'p. ej. Quiero programar anuncios para que empiecen a una hora concreta…',
    send: 'Enviar petición',
    tooShort: 'Cuéntanos un poco más (al menos 10 caracteres).',
    tooLong: 'Mantén tu petición por debajo de 2.000 caracteres.',
    successTitle: 'Gracias, tu petición se ha enviado.',
    successBody: 'Te contactaremos si necesitamos más detalles.',
    reference: 'Referencia n.º {ticket}',
    errorGeneric: 'No pudimos enviar tu petición. Inténtalo de nuevo.',
    retry: 'Reintentar',
  },
  referAndEarn: {
    shareYourLink: 'Comparte tu enlace',
  },
  // Espacio de trabajo "Revisar y publicar"
  review: {
    top: {
      back: 'Atrás',
      breadcrumb: 'Dónde estás',
      live: 'Publicado en tu tienda',
      draft: 'Borrador — aún no publicado',
      page: 'Página',
      part: 'Parte de la página',
      productCard: 'Ficha de producto',
      landingPage: 'Página de aterrizaje',
      undo: 'Deshacer',
      redo: 'Rehacer',
      history: 'Historial de versiones',
      themeEditor: 'Abrir en el editor de temas',
      viewOnStore: 'Ver en la tienda',
      panel: 'Mostrar u ocultar el panel de edición',
      zoom: 'Zoom de la vista previa',
      zoomFit: 'Ajustar',
      expand: 'Ampliar vista previa',
      collapse: 'Salir de pantalla completa',
    },
    canvas: {
      toolbar: 'Acciones para {label}',
      editWithAi: 'Editar con IA',
      replaceImage: 'Reemplazar imagen',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      duplicate: 'Duplicar',
      hide: 'Ocultar',
      show: 'Mostrar',
      delete: 'Eliminar',
      deleteIt: 'Eliminar',
      thisElement: 'este elemento',
      deleteConfirm: '¿Eliminar “{label}”? Podrás deshacerlo después.',
      locked: 'Los botones de compra no se editan aquí',
      updating: 'Actualizando {label}…',
      updatingPage: 'Actualizando toda la página…',
      saving: 'Guardando…',
      failed: 'El cambio no se aplicó',
      failedOn: 'El cambio en {label} no se aplicó',
      retry: 'Reintentar',
      plainFallback: 'mostramos la vista previa simple.',
    },
    composer: {
      editing: 'Editando: {label}',
      wholePage: 'Toda la página',
      clearScope: 'Quitar la selección',
      placeholder: 'Describe un cambio para toda la página…',
      placeholderScoped: 'Describe un cambio para {label}…',
      wholePageBusy: 'Actualizando toda la página — puedes seguir mirando.',
      cancelConfirm: '¿Cancelar esta actualización?',
      cancelTitle: 'Cancelar actualización',
      cancelIt: 'Cancelar',
    },
    prompts: {
      pagePremium: 'Un tono más premium',
      pageShorter: 'Acorta todo un 20%',
      pageFaq: 'Añade una sección de preguntas frecuentes',
      pageStory: 'Haz la historia más personal',
      pageCta: 'Refuerza la llamada a la acción',
      headlinePunchier: 'Un titular más contundente',
      headlineShorter: 'Acórtalo',
      headlineBenefit: 'Empieza por el beneficio principal',
      textTighter: 'Afina el texto',
      textConcrete: 'Hazlo más concreto',
      textFriendly: 'Hazlo más cercano',
      buttonAction: 'Orientado a la acción',
      buttonUrgency: 'Añade algo de urgencia',
      imageLifestyle: 'Usa una imagen lifestyle',
      imageBrighter: 'Fondo más claro y limpio',
      sectionTrust: 'Añade sellos de confianza',
      sectionTighter: 'Afina el texto',
      sectionTestimonial: 'Añade un testimonio',
    },
    panel: {
      label: 'Panel de edición',
      collapse: 'Contraer el panel',
      open: 'Panel',
      tabs: { edit: 'Editar', sections: 'Secciones', images: 'Imágenes', brand: 'Marca', details: 'Detalles' },
    },
    edit: {
      emptyTitle: 'Nada seleccionado',
      emptyBody: 'Haz clic en cualquier parte de la página para editarla.',
      inSection: 'en {section}',
      noFields: 'Esta parte no tiene campos de texto o imagen — usa “Editar con IA”.',
      buttonLabel: '{label} · texto',
      buttonLink: '{label} · enlace',
      saved: 'Guardado',
      hintEnter: 'Enter para guardar',
      hintBlur: 'Se guarda al salir del campo',
      replace: 'Reemplazar',
      generate: 'Generar',
      upload: 'Subir',
      uploading: 'Subiendo…',
      uploadFailed: 'No se pudo subir la imagen.',
      pickImage: 'Elige una imagen',
      noLibrary: 'Aún no hay imágenes generadas para este producto — sube una.',
      useImage: 'Usar imagen',
      generatePrompt: 'Genera una imagen nueva para este espacio — mismo producto, composición más limpia. Adjunta una referencia si quieres un estilo concreto.',
    },
    sections: {
      hide: 'Ocultar {label}',
      show: 'Mostrar {label}',
      none: 'No se encontraron secciones en esta página.',
      add: 'Añadir sección',
      dragHint: 'Arrastra el asa para reordenar. Las secciones ocultas siguen en la página pero no se ven en tu tienda.',
      libraryTitle: 'Añadir una sección',
      libraryHint: 'La IA redacta la sección para esta página y la coloca después de la parte que estás viendo.',
      placeAfter: 'Colócala justo después de la sección “{section}”.',
      library: {
        benefits: { name: 'Beneficios', desc: 'Tres o cuatro beneficios con iconos.', instruction: 'Añade una sección de beneficios con 3–4 beneficios concretos, cada uno con un título corto, una frase y un icono simple.' },
        testimonials: { name: 'Testimonios', desc: 'Citas de clientes con nombre y valoración.', instruction: 'Añade una sección de testimonios con tres citas creíbles, nombres de pila, ciudades y valoraciones de 5 estrellas.' },
        faq: { name: 'Preguntas frecuentes', desc: 'Cinco dudas habituales antes de comprar.', instruction: 'Añade una sección de preguntas frecuentes con cinco dudas reales previas a la compra y respuestas concretas y tranquilizadoras.' },
        gallery: { name: 'Galería de imágenes', desc: 'Una cuadrícula con las imágenes existentes.', instruction: 'Añade una galería usando solo imágenes que ya estén en la página, en una cuadrícula limpia.' },
        comparison: { name: 'Tabla comparativa', desc: 'Nosotros frente a las alternativas habituales.', instruction: 'Añade una tabla comparativa: este producto frente a las alternativas típicas, 4–5 filas, con ticks y cruces.' },
        howItWorks: { name: 'Cómo funciona', desc: 'Tres pasos numerados.', instruction: 'Añade una sección “Cómo funciona” con tres pasos numerados, cada uno con un título corto y una frase.' },
        guarantee: { name: 'Garantía', desc: 'Devolución del dinero y notas de envío.', instruction: 'Añade una sección de garantía: promesa de devolución del dinero, envíos y devoluciones en palabras sencillas, con un sello.' },
        cta: { name: 'Llamada a la acción', desc: 'Un banner de cierre con botón.', instruction: 'Añade un banner final de llamada a la acción con un titular potente, una línea de confianza y un botón que enlace al botón de compra o producto existente.' },
      },
    },
    brand: {
      noLogo: 'Aún no se generó un logotipo para este sitio web.',
      colours: 'Colores de marca',
      fonts: 'Tipografías',
      change: 'Cambiar',
      noColours: 'Los colores de marca vienen de tu tema.',
      headingFont: 'Títulos',
      bodyFont: 'Texto',
      themeDefault: 'Por defecto del tema',
    },
    details: {
      product: 'Producto',
      title: 'Título',
      price: 'Precio',
      compareAt: 'Precio anterior',
      none: 'Ninguno',
      status: 'Estado',
      productHint: 'El título, el precio y el precio anterior se leen de Shopify. Edítalos allí — la página se actualiza al publicar.',
      editInShopify: 'Editar producto en Shopify',
      advertorial: 'Advertorial',
      headline: 'Titular',
      linkedProduct: 'Producto enlazado',
      ctaOk: 'La llamada a la acción enlaza a {product}.',
      ctaOther: 'La llamada a la acción enlaza a otro producto.',
      ctaMissing: 'No se encontró ningún enlace al producto — añade uno para que puedan comprar.',
      openProduct: 'Abrir producto',
    },
    pages: {
      publishesWithSite: 'Esta página se crea al publicar el sitio web.',
    },
    coach: {
      step: '{n} de {total}',
      clickTitle: 'Haz clic en cualquier parte para editar',
      clickBody: 'Pasa el cursor para ver qué puedes cambiar, haz clic para seleccionarlo y usa la barra flotante o el panel de la derecha.',
      composerTitle: 'O describe un cambio aquí',
      composerBody: 'Escribe lo que quieres con tus palabras. Con algo seleccionado el cambio se queda dentro; si no, se aplica a toda la página.',
      publishTitle: 'Publica cuando estés conforme',
      publishBody: 'Nada se publica hasta que pulses Publicar. Cada cambio se guarda y se puede deshacer.',
      skip: 'Omitir',
      gotIt: 'Entendido',
    },
    bar: {
      publish: 'Publicar en mi tienda',
      update: 'Actualizar página publicada',
      publishing: 'Publicando…',
      saveDraft: 'Guardar borrador',
      checking: 'Comprobando…',
      review: 'Revisar',
      oneIssue: '1 problema bloquea la publicación',
      nIssues: '{n} problemas bloquean la publicación',
      oneSuggestion: '1 sugerencia',
      nSuggestions: '{n} sugerencias',
      blockedTooltip: 'La publicación está bloqueada',
      blockedTooltipAction: 'Haz clic para revisar y corregir.',
      blockedBy: 'bloqueado por {n} problema(s)',
      whyBlocked: '¿Por qué no puedo publicar? Revisa los problemas',
      savedJustNow: 'Guardado ahora mismo',
      savedAgo: 'Guardado hace {n} min',
      allSaved: 'Todos los cambios guardados',
    },
  },
};

export default es;
